import defaultLayout from '@/layouts/default'
import noAppBarLayout from '@/layouts/no-app-bar'

const map = {
  'default-layout': defaultLayout,
  'no-app-bar-layout': noAppBarLayout
}

export default Vue => {
  Object.entries(map).forEach(([key, layout]) => {
    Vue.component(key, layout)
  })
}
